import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64629971"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "admin",
  class: "view"
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bottom" }, null, -1))

import { computed, ComputedRef, onBeforeMount } from 'vue'

  import NotFound from '@/components/Common/NotFound.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { TAppConfig, IAppStatistics } from '@/types/application'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore()

  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const appStatistics: ComputedRef<IAppStatistics> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_STATS]
  )
  const isAuthUserAmin: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_ADMIN]
  )
  const userLoading: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.USER_LOADING]
  )

  onBeforeMount(() => store.dispatch(ROOT_STORE.ACTIONS.GET_APPLICATION_STATS))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(userLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(isAuthUserAmin))
            ? (_openBlock(), _createBlock(_component_router_view, {
                key: 0,
                appConfig: _unref(appConfig),
                appStatistics: _unref(appStatistics)
              }, null, 8, ["appConfig", "appStatistics"]))
            : (_openBlock(), _createBlock(NotFound, { key: 1 })),
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})